module.exports = __webpack_public_path__ + "static/media/login-logo.0dbc6403.png";